import { ChangeDetectorRef, Component, Input, ViewContainerRef } from '@angular/core';
import { AngularComponentFactory } from 'survey-angular-ui';
import { CorporateStructureOfficeListWidgetModel } from './corporate-structure-office-list.widget.model';
import { RendererFactory } from 'survey-core';
import { FormBuilder } from '@angular/forms';
import { SurveyService } from '../../../../core/services/survey/survey.service';
import { VariablesService } from '../../../../core/services/survey/variables.service';
import { TangillaQuestion } from '../tangilla-question';
import { QuestionsService } from '../../../../core/services/survey/questions.service';
import { OfficesApiService, MemberPeopleApiService, SnackbarService } from '@tangilla/tg-ng-core';
import { ErrorsService } from '../../../../core/services/utils/errors.service';

@Component({
  selector: 'tgf-corporate-structure-office-list-widget',
  templateUrl: './corporate-structure-office-list.widget.component.html',
  styleUrls: ['./corporate-structure-office-list.widget.component.scss']
})

export class CorporateStructureOfficeListWidgetComponent extends TangillaQuestion<CorporateStructureOfficeListWidgetModel> {
  offices: any[] = [];
  isLoading = false;

  constructor(
    public memberPeopleApiService: MemberPeopleApiService,
    public officesApiService: OfficesApiService,
    public variablesService: VariablesService,
    private snackbarService: SnackbarService,
    private errorsService: ErrorsService,
    formBuilder: FormBuilder,
    surveyService: SurveyService,
    questionsService: QuestionsService,
    changeDetectorRef: ChangeDetectorRef,
    viewContainerRef?: ViewContainerRef
  ) {
    super(formBuilder,
      surveyService,
      questionsService,
      changeDetectorRef,
      viewContainerRef);
  }

  override ngOnInit() {
    super.ngOnInit();
    this.initializeQuestion();
  }

  initializeQuestion() {
    this.isLoading = true;
    this.changeDetectorRef.detectChanges();
    if (this.surveyService.personId && this.surveyService.personId !== null) {
      this.memberPeopleApiService.getPersonCorporateStructureInformation((this.surveyService.personId as number).toString())
      .subscribe(
        {
          next: (response: any) => {
            this.offices = response.map((office: any) => ({
              ...office,
              showDetails: false
            }));

            // If length is 0, we want to check by office selection as well
            if(this.offices.length === 0){
              const officeId = this.surveyService.surveyModel.getValue('office');
              if(officeId){
                this.officesApiService.getOfficeCorporateStructureInformation(officeId.toString())
                .subscribe(
                  {
                    next: (response: any) => {
                      this.offices = response.map((office: any) => ({
                        ...office,
                        showDetails: false
                      }));
                      this.isLoading = false;
                      this.changeDetectorRef.detectChanges();
                    },
                    error: error => {
                        this.isLoading = false;
                        this.changeDetectorRef.detectChanges();
                        this.errorsService.processError(error, 'soft')
                        this.changeDetectorRef.detectChanges();
                    }
                  }
                );
              }
            } else {
              this.isLoading = false;
              this.changeDetectorRef.detectChanges();
            }

          },
          error: error => {
              this.isLoading = false;
              this.changeDetectorRef.detectChanges();
              this.errorsService.processError(error, 'soft')
              this.changeDetectorRef.detectChanges();
          }
        }
      );
    }else{
      const officeId = this.surveyService.surveyModel.getValue('office');
      this.officesApiService.getOfficeCorporateStructureInformation((officeId).toString())
      .subscribe(
        {
          next: (response: any) => {
              this.offices = response.map((office: any) => ({
                ...office,
                showDetails: false
              }));
            this.isLoading = false;
            this.changeDetectorRef.detectChanges();
          },
          error: error => {
              this.isLoading = false;
              this.changeDetectorRef.detectChanges();
              this.errorsService.processError(error, 'soft')
              this.changeDetectorRef.detectChanges();
          }
        }
      );
    }

  }


  toggleDetails(office: any) {
    if (!office.branches || office.branches.length === 0) {
      return;
    }
    office.showDetails = !office.showDetails;
    this.changeDetectorRef.detectChanges();
  }

  isItLoading() {
    return this.isLoading;
  }
}

RendererFactory.Instance.registerRenderer(
  'corporate_structure_office_list',
  'corporate_structure_office_list',
  'tg_corporate_structure_office_list',
  true
);
AngularComponentFactory.Instance.registerComponent('tg_corporate_structure_office_list', CorporateStructureOfficeListWidgetComponent);
